import { Module } from '@nestjs/common';
import { ConfigModule } from '@nestjs/config';
import configuration from '../config/configuration';
import { DatabaseModule } from '../database';
import { AIGeneratedQpModule } from './ai-generated-qp/ai-generated-qp.module';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { QuestionBankCreationModule } from './create-questions/create-question-module';
import { ModelPaperModule } from './model-paper/model-paper.module';
import { AuthenticationsModule } from './authentications/authentications.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { TranslationModule } from './translation/translation.module';

@Module({
  imports: [
    ConfigModule.forRoot({
      isGlobal: true,
      envFilePath: './.env',
      load: [configuration],
    }),
    DatabaseModule,
    AIGeneratedQpModule,
    ModelPaperModule,
    QuestionBankCreationModule,
    AuthenticationsModule,
    DashboardModule,
    TranslationModule
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
